import React from "react";
import PriceOptions from "./PriceOptions";
import PriceTable from "./PriceTable";
import LearnMore from "./LearnMore";

import "./summary.scss";

const Summary = (props) => {
	let learnMore;
	let priceOptions;
	let priceTable;
	let vatRow;
	const { selectedOption, product, currencySymbol } = props;
	const { name, description } = selectedOption;

	if (props.vatId) {
		const message = `${props.vatRate}% VAT, VAT number ${
			props.vatId
		}`;
		vatRow = <p className="okpay-vat">{message}</p>;
	}

	if (selectedOption.displayPrice) {
		priceTable = <PriceTable {...props} />;
	}

	if (product.learnMore) {
		learnMore = (
			<LearnMore link={product.learnMoreLink}>{product.learnMore}</LearnMore>
		);
	}

	if (product.options.length > 1) {
		priceOptions = (
			<PriceOptions
				options={product.options}
				optionPicked={product.optionPicked}
				product={product}
				currencySymbol={currencySymbol}
			/>
		);
	}

	return (
		<div className="okpay-summary">
			{props.optionsBeforeTitle && priceOptions}
			<h3 className="okpay-summary-name">{name}</h3>
			{props.optionsAfterTitle && priceOptions}
			<p className="okpay-summary-description">{description}</p>
			{learnMore}
			{priceTable}
			{vatRow}
		</div>
	);
};

export default Summary;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/Summary.jsx